import { useTranslation } from "react-i18next";
import { useCurrentApp } from "@/hooks/useCurrentApp";
import { useUploadDrawerStore } from "@/store";
import { useConfirmDropUploads } from "@/pages/app-detail/versions/useConfirmDropUploads";
import InfoIcon from "@/assets/info.svg?react";

export function Banner() {
  const { t } = useTranslation();
  const app = useCurrentApp();
  const openNewVersion = useUploadDrawerStore((s) => s.openNewVersion);
  const confirmDropUploads = useConfirmDropUploads();

  return (
    <div className="flex items-center justify-between rounded-lg bg-[#FF8D2829] px-4 py-2.5">
      <div className="flex items-center gap-2 text-sm text-primary">
        <InfoIcon className="text-[#F77234] size-4" />
        <span>{t("security.banner")}</span>
      </div>
      <button
        type="button"
        className="inline-flex items-center gap-1 border-0 bg-transparent p-0 text-sm text-accent cursor-pointer"
        onClick={() => confirmDropUploads(() => openNewVersion(app.id))}
      >
        {t("security.viewVersion")}
      </button>
    </div>
  );
}
